module.exports = __webpack_public_path__ + "static/img/attention_pop_bg.d194f19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attention_pop_bg.png
// module id = 3oGM
// module chunks = 124